const detachedOffset = 10;

const snapScrollToBottom = (node: HTMLElement) => {
  let prevScrollValue = node.scrollTop;
  let isDetached = false;

  const handleScroll = () => {
    // if user scrolled up, we detach
    if (node.scrollTop < prevScrollValue) {
      isDetached = true;
    }

    // if user scrolled back to within 10px of bottom, we reattach
    if (node.scrollTop - (node.scrollHeight - node.clientHeight) >= -detachedOffset) {
      isDetached = false;
    }

    prevScrollValue = node.scrollTop;
  };

  const updateScroll = () => {
    if (isDetached) return;

    node.scrollTo({ top: node.scrollHeight, behavior: 'smooth' });
  };

  node.addEventListener('scroll', handleScroll);

  return {
    updateScroll,
    destroy: () => {
      node.removeEventListener('scroll', handleScroll);
    },
  };
};

export default snapScrollToBottom;
